import cx from "classnames";
import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import { NavLinkItemsQuery } from "../../graphql-types";
import InternalLink from "./InternalLink";

type Props = {
  absolutePath: string;
  hardcodedLinks?: {
    title: string;
    path: string;
  }[];
  isResponsive?: boolean;
};

type LinkNodeType = { path: string; title: string };

const STATIC_QUERY = graphql`
  query NavLinkItems {
    home {
      path
      lexicon {
        home
      }
      navLinks {
        title
        path
      }
      signUp {
        path
        title
      }
    }
    allSustainabilityLandingPage {
      nodes {
        title
        path
      }
    }
  }
`;

const NavLinkItems = ({
  hardcodedLinks = [],
  isResponsive,
  absolutePath,
}: Props) => {
  const { home, allSustainabilityLandingPage } =
    useStaticQuery<NavLinkItemsQuery>(STATIC_QUERY);
  if (!home) {
    throw new Error("Could not find home node");
  }

  const links = home.navLinks.concat(hardcodedLinks);
  const liLink = isResponsive
    ? "block py-2 text-lg lg:py-0 lg:text-white lg:font-bold lg:flex lg:items-center lg:text-center"
    : "block py-2";

  const isActive = (path: string) => absolutePath.includes(path);

  const linkNodes: LinkNodeType[] = [];
  let pushed = false;

  links.forEach((el, i) => {
    linkNodes.push(el);
    if (el.title === "Dirt is Good Project" && !pushed) {
      allSustainabilityLandingPage.nodes.forEach((susEl) => {
        linkNodes.push(susEl);
        pushed = true;
      });
    }
    if (
      links.length === i + 1 &&
      links.length === linkNodes.length &&
      allSustainabilityLandingPage.nodes.length
    ) {
      linkNodes.push(...allSustainabilityLandingPage.nodes);
    }
  });

  return (
    <>
      <li
        className={cx("pb-5 mb-5 border-b border-white", {
          active: isActive(home.path),
          "lg:hidden": isResponsive,
        })}
      >
        <InternalLink className={liLink} href={home.path}>
          {home.lexicon.home}
        </InternalLink>
      </li>
      {linkNodes.map((link) => (
        <li key={link.path} className={cx({ active: isActive(link.path) })}>
          <InternalLink className={liLink} href={link.path}>
            {link.title}
          </InternalLink>
        </li>
      ))}
      {home.signUp && (
        <li className={cx({ active: isActive(home.signUp.path) })}>
          <InternalLink className={liLink} href={home.signUp.path}>
            {home.signUp.title}
          </InternalLink>
        </li>
      )}
    </>
  );
};

export default NavLinkItems;
